import { useEffect, useState } from 'react';
import { Breadcrumb, Col, Container, Row } from 'react-bootstrap';
import { IBusiness } from '../../commons/interfaces/business.interface';
import { IChatbotAPIPagination } from '../../commons/interfaces/chatbotAPI.interface';
import CustomTable from '../../components/CustomTable';
import Paper from '../../components/Paper';
import BusinessAPI from '../../services/business.service';
import tableColumnMetadata from './table.metadata';

const businessAPI = new BusinessAPI();

const Businesses = () => {
  const initialPagination = { page: 1, pageSize: 10, pageCount: 1, totalCount: 1 };

  const [businesses, setBusinesses] = useState<IBusiness[]>([]);
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [pagination, setPagination] = useState<IChatbotAPIPagination>(initialPagination);

  useEffect(() => {
    const fetchBusinesses = async () => {
      setLoading(true);
      const response = await businessAPI.listBusinesses(page);

      setBusinesses(response.data);
      setPagination(response.pagination);
      setLoading(false);
    };

    fetchBusinesses();
  }, [page]);

  const handleFooterClick = (value: number) => {
    setPage(page + value);
  };

  const footerProps = {
    onClick: handleFooterClick,
    pagination,
    loading
  };

  return (
    <Container id="businesses" fluid>
      <Breadcrumb className="breadcrum">
        <Breadcrumb.Item active>Gestión de tickets</Breadcrumb.Item>
      </Breadcrumb>
      <Paper>
        <Row className="justify-content-space-between mb-4">
          <Col className="d-flex m-auto">
            <span>Lista de contratista</span>
          </Col>
        </Row>
        <Row>
          <Col>
            <CustomTable<IBusiness>
              data={businesses}
              loading={loading}
              footerProps={footerProps}
              columnsMetadata={tableColumnMetadata}
            />
          </Col>
        </Row>
      </Paper>
    </Container>
  );
};

export default Businesses;
